export const tableRangeSettings = {
	drawer: {
		title: "Configurar ambientes",
		saveBtn: "Guardar",
	},
	header: {
		addBtn: "Añadir ambiente",
		searchPlaceholder: "Buscar por bar",
	},
	card: {
		title: "Ambiente {{from}} a {{to}}",
		subtitle: "Mesas {{from}} a {{to}}",
		barsLabel: "Imprimir en barras",
		deleteBtn: "Eliminar ambiente",
		hideBtn: "Ocultar",
	},
	list: {
		emptyState: {
			title: "Aún no hay nada aquí",
			subtitle: "No has añadido ambientes para tu establecimiento.",
		},
	},
	form: {
		status: {
			errors: {
				description:
					"No ha sido posible añadir el rango. Comprueba si no hay un número de mesa que ya se haya utilizado en otro rango.",
				title: "Algo ha salido mal.",
			},
			success: {
				titleEditing: "Actualizado correctamente.",
				titleCreating: "¡Rangos de mesas creados correctamente!",
			},
		},
		generalWrapperLabel: "Rango {{number}}",
		intervalWrapperLabel: "Rango de mesas",
		bars: {
			label: "Bares que imprimirán pedidos desde este entorno",
			placeholder: "Buscar por nombre",
			selectedBar: "bar seleccionado",
			selectedBars_one: "{{count}} bar seleccionado",
			selectedBars_other: "{{count}} bares seleccionados",
		},
		environmentNameLabel: "Nombre del ambiente",
		environmentNamePlaceholder: "Define un título para este grupo de mesas",
		removeIntervalBtn: "Eliminar rango",
		editingWarningTooltip: "No puedes añadir nuevos rangos en el modo edición.",
		addIntervalBtn: "Añadir otro ambiente",
		errors: {
			missingEnvironmentName: "Escribe el nombre del ambiente (rango {{number}})",
			atLeastOneBar:
				"Debes seleccionar al menos una barra para imprimir los pedidos de las mesas de arriba. (rango {{number}})",
			missingFromTable:
				"Escribe el número de la primera mesa del rango (rango {{number}})",
			missingToTable: "Escribe el número de la última mesa del rango (rango {{number}})",
			fromTableAlreadyUsed:
				"La primera mesa del rango (rango {{number}}) ya se usa en otro rango.",
			toTableAlreadyUsed:
				"La última mesa del rango (rango {{number}}) ya se usa en otro rango.",
		},
	},
	deleteModal: {
		title: "¿Desea eliminar este ambiente?",
		messageLine1:
			"Las mesas asignadas también serán eliminadas, pero los datos relacionados se mantendrán en sus informes.",
		messageLine2: "No será posible deshacer esta acción.",
		confirmBtn: "Sí, deseo eliminar",
	},
	tabs: {
		generalSettings: "Configuración general",
		printByTableSettings: "Configurar impresión por mesa",
	},
};
